import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { BankAppConfiguration } from '../../types/sdk';

type SavedAuthState = {
	init: true;
	URL: string;
	tokens: {
		access: string;
		refresh: string;
		invite: string;
	};
};

type BaseAuthState = {
	init: false;
};

type AuthState = SavedAuthState | BaseAuthState;

const initialState: AuthState = {
	init: false
};

export const authSlice = createSlice({
	name: 'auth',
	initialState: initialState satisfies AuthState as AuthState,
	reducers: {
		saveAuthentication(_, action: PayloadAction<BankAppConfiguration>) {
			const configuration = action.payload;
			return {
				init: true,
				URL: configuration.url,
				tokens: {
					access: configuration.shortTermToken,
					refresh: configuration.longTermToken,
					invite: configuration.inviteToken
				}
			};
		},
		setAccessToken(state, action: PayloadAction<string>) {
			if (!state.init) return;
			state.tokens.access = action.payload;
		}
	}
});

export const { setAccessToken, saveAuthentication } = authSlice.actions;

export const selectServiceURL = (state: RootState): string | undefined => {
	if (!state.auth.init) return undefined;
	return state.auth.URL;
};

export const selectAccessToken = (state: RootState): string | undefined => {
	if (!state.auth.init) return undefined;
	return state.auth.tokens.access;
};

export const selectRefreshToken = (state: RootState): string | undefined => {
	if (!state.auth.init) return undefined;
	return state.auth.tokens.access;
};

export const selectInviteToken = (state: RootState): string | undefined => {
	if (!state.auth.init) return undefined;
	return state.auth.tokens.invite;
};
